<ul class="snackbar">
  <ng-container *ngFor="let message of service.messages; let i = index">
    <ng-container>
      <li class="snackbar__list" @openClose>
        <!-- <div class="snackbar__list-status -{{ message.type }}"></div> -->
        <div class="snackbar__list-title">{{ message.message }}</div>
        <div
          class="snackbar__list-close"
          (click)="service.deleteMessage(message.id)"
        ></div>
      </li>
    </ng-container>
  </ng-container>
</ul>
